import { type useAuth } from '@clerk/clerk-react'
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'
import { ErrorPanel } from '@/components/feedback/ErrorPanel'

export interface RouterContext {
  /** Clerk auth snapshot, injected by `<RouterProvider context={{auth}}>`. */
  auth: ReturnType<typeof useAuth>
}

/**
 * Root of the route tree. Renders only matched children — the app chrome
 * (Sidebar/Topbar/JobsWatcher) lives in `appShellRoute` so non-app routes
 * like `/login` render standalone.
 */
export const rootRoute = createRootRouteWithContext<RouterContext>()({
  component: () => <Outlet />,
  errorComponent: ({ error, reset }) => <ErrorPanel error={error} onReset={reset} />,
  notFoundComponent: () => (
    <ErrorPanel
      error={null}
      title="Página não encontrada"
      description="Esse endereço não existe no Prism. Confira o link ou volte ao início."
      onReset={() => {
        window.location.href = '/'
      }}
    />
  ),
})
